module.exports = __webpack_public_path__ + "img/logo.6a4c7733.png";